import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: true,
  imports: [IonicModule, CommonModule, TranslateModule]
})
export class FooterComponent {
  protected disablePrimaryButton = false;
  protected disableSecondaryButton = false;
  @Input() primaryButtonText = '';
  @Input() secondaryButtonText = '';
  @Input() primaryButtonIcon = '';
  @Input() secondaryButtonIcon = '';
  @Input() isTermsAndPrivacy = false;
  @Input() isReference = false;
  @Input() showPrimaryButton = true;
  @Input() showSecondaryButton = true;
  @Input() showPrimaryButtonIcon = true;
  @Input() showSecondaryButtonIcon = true;

  @Input() public set shouldDisablePrimaryButton(shouldDisablePrimaryButton: boolean) {
    this.disablePrimaryButton = shouldDisablePrimaryButton;
  };

  @Input() public set shouldDisableSecondaryButton(shouldDisableSecondaryButton: boolean) {
    this.disableSecondaryButton = shouldDisableSecondaryButton;
  };

  @Output() primaryButtonClickEvent = new EventEmitter<string>();
  @Output() secondaryButtonClickEvent = new EventEmitter<string>();

  protected primaryButtonClick($event?) {
    this.primaryButtonClickEvent.emit($event);
  }

  protected secondaryButtonClick($event?) {
    this.secondaryButtonClickEvent.emit($event);
  }

}
